<template>
  <v-container fluid grid-list-md>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="checkConnections" @cancel="closeDialogDelete"></p-confirm>
    <!--Dialog que verifica -->
    <p-confirm text="Todos os registro relacionados com essa empresa serão deletados. Deseja realmente excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="confirmDeleteDialog" @confirm="acceptConfirmDelete" @cancel="closeConfirmDelete"></p-confirm>
    <!-- Dialog para confirmação de edição em uma situação em que já existe algum usuário editando a equipe -->
    <p-confirm text="Existem usuários realizando a edição desta empresa, poderá haver conflitos. Deseja continuar" :dialog="confirmEditDialog" @confirm="confirmEdit" @cancel="confirmEditDialog = false"></p-confirm>
    <!--Index-->
    <!--Foi colocado o v-show para que não suma o filtro do PFilter-->
    <!-- adicionado o view === 1 pois ao ir em gerenciar uma empresa direto estava abrindo a tela de consulta pra depois a tela de gerenciamento -->
    <v-layout v-show="!dialog && view === 1" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.companies.icon')}}</v-icon>{{formTitle}}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <p-filter
          ref="filter"
          :allItems="allItems"
          :entity="entity"
          :filterTypes="filterTypes"
          @customFilter="(res)=>{items=res}">
        </p-filter>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
          :custom-filter="customizedFilter" style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id_text }}</td>
            <td>{{ props.item.cpfcnpj ? maskField(props.item.cpfcnpj, props.item.type_person === 1 ? '###.###.###-##' : '##.###.###/####-##') : '' }}</td>
            <td>{{ props.item.illis_name }}</td>
            <td>{{ props.item.company_plan.length > 0 ? props.item.company_plan[0].plan.id_text : 'Grátis' }}</td>
            <!-- O campo ativo foi ocultado da tela de companhia. Posteriormente será retrabalhado e voltará a ser exibido
            <td>
              <v-checkbox v-model="props.item.active" readonly class="mx-auto"></v-checkbox>
            </td> -->
            <td v-if="props.item.user[0].status === 1" align="center" style="min-width: 128px">
              <v-tooltip bottom>
                <v-btn icon slot="activator" class="mx-0" @click=acceptInvite(props.item)>
                  <v-icon color="green">done</v-icon>
                </v-btn>
                <span>
                  Aceitar
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn icon slot="activator" class="mx-0" @click=denyInvite(props.item)>
                  <v-icon color="pink">close</v-icon>
                </v-btn>
                <span>
                  Recusar
                </span>
              </v-tooltip>
            </td>
            <td v-else align="center">
              <v-tooltip bottom>
                <v-btn icon slot="activator" class="mx-0">
                  <v-icon color="grey darken-1">list</v-icon>
                </v-btn>
                <span>
                  <p-other-field :reload="reload" :othersFields="othersFields(props.item)"></p-other-field>
                </span>
              </v-tooltip>
              <v-menu
                left
                nudge-top="8"
                content-class="elevation-0 menu_content"
                transition="slide-x-reverse-transition"
                :offset-x="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small slot="activator" v-on="on" icon class="mx-0">
                    <v-icon medium>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-tooltip bottom>
                  <v-btn slot="activator" small fab class="mx-0" @click="editItemProcess(props.item, 4)" :disabled="!checkAdminPermission(props.item.user[0].admin, props.item.id, 'Gerenciar')">
                    <v-icon color="teal">build</v-icon>
                  </v-btn>
                  <span>{{companiesPermissionTooltip[`${props.item.id}_${'Gerenciar'}`]}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" small fab class="mx-0" @click="dialogDelete(props.item)" :disabled="!checkAdminPermission(props.item.user[0].admin, props.item.id, 'Excluir')">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>{{companiesPermissionTooltip[`${props.item.id}_${'Excluir'}`]}}</span>
                </v-tooltip>
              </v-menu>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!------------------------->
    <v-form v-if="dialog" v-model="valid" @keyup.native.ctrl.enter="view === 3 ? save(4) : saveEdit()" ref="form">
      <v-layout wrap justify-center align-center>
        <v-flex :class="(view === 4) ? 'xs10' : 'xs12'">
          <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
        </v-flex>
        <v-flex v-if="view === 4" xs2 class="text-xs-right">
          <p-edit-btn :tooltipText="companiesPermissionTooltip[`${editedItem.id}_${'Editar'}`] !== 'Editar' ? companiesPermissionTooltip[`${editedItem.id}_${'Editar'}`] : editTooltipText" @onClick="checkEditRoomEmpty(editedItem, 3)" :disabled="!checkAdminPermission(editedItem.user[0].admin, editedItem.id, 'Editar')">
          </p-edit-btn>
        </v-flex>
        <!--Management-->
        <v-container fluid grid-list-xs style="padding: 2px" v-if="view === 4">
          <div class="p-gradient">
            <v-layout row wrap>
              <v-flex xs12 md4>
                <div class="p-white text-xs-center">
                  <v-avatar size="150px" v-ripple v-if="!editedItem.logo_path" class="grey lighten-3">
                    <span>Não existe logo</span>
                  </v-avatar>
                  <v-avatar size="150px" v-ripple v-else>
                    <img :src="blobImage?editedItem.logo_path:`${basePath}uploads/companies/${editedItem.logo_path}`" alt="avatar">
                  </v-avatar>
                </div>
              </v-flex>
            <v-flex xs12 md8>
              <v-layout row wrap justify-center>
                <v-flex xs12>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.id_text')}}</div>
                      <div class="p-content"> {{editedItem.id_text}}</div>
                    </div>
                  </v-flex>
                  <!-- Campo ocultado bug 771 -->
                  <!-- <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.fantasy_name')}}</div>
                      <div class="p-content"> {{editedItem.fantasy_name}}</div>
                    </div>
                  </v-flex> -->
                  <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.illis_name')}}</div>
                      <div class="p-content"> {{editedItem.illis_name}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.type_person')}}</div>
                      <div class="p-content"> {{translate('value.company_type_person').find((val) => { return val.value === editedItem.type_person}).text}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.cpfcnpj')}}</div>
                      <div class="p-content">{{maskField(editedItem.cpfcnpj, editedItem.type_person === 1 ? '###.###.###-##' : '##.###.###/####-##')}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <div class="p-white">
                      <div class="p-label">{{translate('table.' + entity + '.field.rgie')}}</div>
                      <div class="p-content"> {{editedItem.rgie}}</div>
                    </div>
                  </v-flex>                
                </v-layout>
              </v-flex>
              <!-- Campo ocultado bug 771 -->
              <!-- <v-flex xs12 md6>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.market')}}</div>
                  <div class="p-content"> {{editedItem.market}}</div>
                </div>
              </v-flex> -->
              <v-flex xs12 md4>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.city')}}</div>
                  <div class="p-content"> {{editedItem.city ? (editedItem.city + ', ' + editedItem.state + ', ' + editedItem.country) : ''}}</div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.cep')}}</div>
                    <div class="p-content"> {{editedItem.cep ? maskField(editedItem.cep, '#####-###') : ''}}</div>
                </div>
                <!-- <v-text-field :label="translate('table.' + entity + '.field.cep')"
                              v-model="editedItem.cep" mask="#####-###"></v-text-field> -->
              </v-flex>
              <v-flex xs12 sm4>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.neighborhood')}}</div>
                    <div class="p-content"> {{editedItem.neighborhood}}</div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.complement')}}</div>
                    <div class="p-content"> {{editedItem.complement}}</div>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.address')}}</div>
                    <div class="p-content"> {{editedItem.address}}</div>
                </div>
              </v-flex>
              <v-flex xs12 sm2>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.number')}}</div>
                    <div class="p-content"> {{editedItem.number}}</div>
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.phone')}}</div>
                    <div class="p-content">{{maskField(editedItem.phone, '(##)#####-####')}}</div>
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.email')}}</div>
                    <div class="p-content"> {{editedItem.email}}</div>
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="p-white">
                    <div class="p-label">{{translate('table.' + entity + '.field.segments')}}</div>
                    <div class="p-content"> {{editedItem['segment'] ? editedItem['segment']['id_text'] : ''}}</div>
                </div>
              </v-flex>
              <!-- Campo ocultado bug 771 -->
              <!-- <v-flex xs12>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.links')}}</div>
                  <div class="p-content"> {{editedItem.links}}</div>
                </div>
              </v-flex> -->
              <v-flex xs12>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.bio')}}</div>
                  <div class="p-content" style="white-space: pre-line;"> {{editedItem.bio}}</div>
                </div>
              </v-flex>
              <!-- O campo ativo foi ocultado da tela de companhia. Posteriormente será retrabalhado e voltará a ser exibido
              <v-flex xs12>
                <div class="p-white">
                  <div class="p-label">{{translate('table.' + entity + '.field.active')}}</div>
                  <div class="p-content">{{translate('system.bollean')[editedItem.active]}}</div>
                </div>
              </v-flex> -->
            </v-layout>
          </div>
        </v-container>
        <!--Create Edit-->
        <v-container fluid grid-list-xs style="padding: 2px" v-else>
          <v-layout row justify-space-between wrap>
            <v-flex xs12 md4>
              <div class="text-xs-center">
                <p-upload-cropped-image v-model="editedItem.logo_path" @changeImage="changeImage">
                  <div slot="activator">
                    <v-avatar size="150px" v-ripple v-if="!editedItem.logo_path" class="grey lighten-3">
                      <span>Clique para adicionar uma foto</span>
                    </v-avatar>
                    <v-avatar size="150px" v-ripple v-else>
                      <img :src="blobImage?editedItem.logo_path:`${basePath}uploads/companies/${editedItem.logo_path}`" alt="avatar">
                    </v-avatar>
                  </div>
                </p-upload-cropped-image>
              </div>
            </v-flex>
            <v-flex xs12 md8>
              <v-layout row wrap justify-center align-center>
                <v-flex xs12>
                  <v-text-field maxlength="190" counter="190" ref="autofocus" :label="translate('table.' + entity + '.field.id_text')"
                                :rules="requiredRule(translate('table.' + entity + '.field.id_text'))" v-model="editedItem.id_text"
                  ></v-text-field>
                </v-flex>
                <!-- Campo ocultado bug 771 -->
                <!-- <v-flex xs12 md6>
                  <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.fantasy_name')"
                                v-model="editedItem.fantasy_name"
                  ></v-text-field>
                </v-flex> -->
                <v-flex xs12 md6>
                  <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.illis_name')" v-model="editedItem.illis_name"
                                :error-messages="field_errors[0].text" :loading="field_errors[0].loading" @blur="existIllisDBRule('illis_name', 0)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select @input="labels" :label="translate('table.' + entity + '.field.type_person')" name="type_person"
                     v-model="editedItem.type_person" :rules="requiredRule(translate('table.' + entity + '.field.type_person'))" :items="translate('value.company_type_person')">
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field :label="cpfcnpj_label" name="cpfcnpj" :rules="fixedSizeRule(cpfcnpj_label, editedItem.type_person == 1 ? 11 : 14, false)"
                      :mask="cpfcnpj_mask" v-model="editedItem.cpfcnpj" validate-on-blur :error-messages="field_errors[1].text" :loading="field_errors[1].loading" @blur="existIllisDBRule('cpfcnpj', 1)">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field :label="rgie_label" name="rgie"
                        maxlength="190" counter="190" v-model="editedItem.rgie">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- Campo ocultado bug 771 -->
            <!-- <v-flex xs12 md6>
            <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.market')"
                          v-model="editedItem.market"
            ></v-text-field>
            </v-flex> -->
            <v-flex xs12 md4>
              <vuetify-google-autocomplete
                ref="address"
                id="googleMap"
                v-model="editedItem.googleMap"
                append-icon="search"
                :disabled="false"
                placeholder="Selecione uma Cidade"
                label="Cidade"
                types='(cities)'
                clearable
                v-on:blur="controlGoogleAutocomplete"
                v-on:placechanged="getCityData"
              >
              </vuetify-google-autocomplete>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field :label="translate('table.' + entity + '.field.cep')"
                  v-model="editedItem.cep" mask="#####-###">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field :label="translate('table.' + entity + '.field.neighborhood')" name="neighborhood"
                 maxlength="190" counter="190" v-model="editedItem.neighborhood">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.complement')" name="complement"
                v-model="editedItem.complement">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field :label="translate('table.' + entity + '.field.address')" name="address"
                  v-model="editedItem.address" maxlength="190" counter="190" >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm2>
              <v-text-field :label="translate('table.' + entity + '.field.number')" name="number"
                  maxlength="190" counter="190" v-model="editedItem.number">
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.phone')"
                  v-model="editedItem.phone" mask="(##) #####-####"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field maxlength="190" counter="190" :label="translate('table.' + entity + '.field.email')"
                  v-model="editedItem.email" :rules="emailRule(translate('table.' + entity + '.field.email'), false, false)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                style=""
                attach
                item-value="segment_id"
                item-text="id_text"
                :rules="requiredRule(translate('table.' + entity + '.field.segments'))"
                :items="translate('value.company_segments')"
                label="Segmentos*"
                return-object
                name="company_segments" 
                v-model="editedItem.segment"
              ></v-autocomplete>
              <!-- multiple -->
              <!-- small-chips -->
            </v-flex>
            <!-- Campo ocultado bug 771 -->
            <!-- <v-flex xs12>
              <v-textarea maxlength="10000" counter="10000" :label="translate('table.' + entity + '.field.links')"
                            v-model="editedItem.links"
              ></v-textarea>
            </v-flex> -->
            <v-flex xs12>
              <v-textarea maxlength="250" counter="250" :label="translate('table.' + entity + '.field.bio')"
                            v-model="editedItem.bio"
              ></v-textarea>
            </v-flex>
            <!-- O campo ativo foi ocultado da tela de companhia. Posteriormente será retrabalhado e voltará a ser exibido
            <v-flex xs12>
              <v-switch :label="translate('table.' + entity + '.field.active')"
                            v-model="editedItem.active"></v-switch>
            </v-flex> -->
          </v-layout>
        </v-container>
      </v-layout>
    </v-form>
    <v-layout wrap justify-center align-center>
      <v-flex v-if="view == 4" xs12>
        <v-tabs dark color="cyan" v-model="tab" grow class="elevation-1">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab href="#0">
            {{this.translate('table.company_user.title')[1]}}
          </v-tab>
          <v-tab href="#1">
            Configurações
          </v-tab>
          <v-tab href="#2">
            {{this.translate('table.payment_bills.title')[1]}}
          </v-tab>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item key="0" value="0">
              <v-card>
                <v-card-text>
                  <user :notBroadcast="false" :company="editedItem"></user>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="1" value="1">
              <v-card>
                <v-card-text>
                  <company-config :companyParams="editedItem.params" @input="(val) => { editedItem.params = val }"></company-config>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="2" value="2">
              <v-card>
                <v-card-text>
                  <payment :company="editedItem"></payment>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout v-if="view === 1"  class="fab-container" align-center>
      <v-tooltip top>
        <v-btn slot="activator" color="primary" dark fab :loading="loading" right @click="create">
          <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.add.title')}}</span>
      </v-tooltip>
    </v-layout>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-tooltip left slot="activator">
          <v-btn v-model="fab" slot="activator" fab color="primary" :loading="loading" dark @click="saveEdit()">
            <v-icon>{{this.translate('system.button.save.icon')}}</v-icon>
            <v-icon>{{this.translate('system.button.build.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_manage.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="accent" :loading="loading" @click="saveProcess()">
            <v-icon>{{this.translate('system.button.save_close.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_close.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="secondary" :loading="loading" @click="saveNew()">
            <v-icon>{{this.translate('system.button.save_new.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_new.title')}}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-tooltip top>
        <v-btn slot="activator" v-if="view === 3" color="primary" :loading="loading" dark fab @click="saveProcess()">
          <v-icon>{{this.translate('system.button.done.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.done.title')}}</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn slot="activator" fab small @click="close">
          <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.close.title')}}</span>
      </v-tooltip>
    </v-layout>
  </v-container>
</template>

<style scoped>
  tr td:last-child {
    min-width: 130px;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
  .speed-dial {
    display: inline !important;
  }
  .p-content{
    word-break: break-all;
  }
</style>

<script>
  import socket from '../mixin/socket'
  import crud from '../mixin/crud'
  import rules from '../mixin/rules'
  import mask from '../mixin/mask'
  import tooltip from '../mixin/tooltip'
  import PFilter from './shared/PFilter'
  import PEditBtn from './shared/PEditBtn'
  import PConfirm from './shared/PConfirm'
  import User from './details/CompanyUser'
  import Payment from './details/CompanyPayment'
  import POtherField from './shared/POtherField'
  import PUploadCroppedImage from './shared/PUploadCroppedImage'
  import CompanyConfig from './details/CompanyConfig'

  export default {
    mixins: [crud, rules, socket, mask, tooltip],
    components: {User, CompanyConfig, Payment, PEditBtn, PFilter, PConfirm, POtherField, PUploadCroppedImage},
    data: () => ({
      companiesPermissionTooltip: {},
      entity: 'companies',
      fab: null,
      cpfcnpj_mask: '###.###.###-##',
      cpfcnpj_label: 'CPF',
      rgie_label: 'RG',
      avatar: null,
      saving: false,
      reload: false,
      accesses: [],
      editedItem: {},
      saved: false,
      tab: null,
      image: '',
      blobImage: false,
      basePath: process.env.API,
      confirmEditDialog: false,
      confirmDeleteDialog: false
    }),
    created () {
      // Assim que a página de empresas é criada, adicionamos o usuário à sala de empresas do Socket.io
      // As empresas são pessoais, então essa sala funciona de maneira diferente das outras: o nome da sala é a junção
      // da propriedade 'entity' com o id do usuário ao invés da junção com o id da empresa logada.
      this.$socket.emit('joinRoom', {room: this.socketRoom})
      this.$store.commit('loader/change_dialog', true)

      this.$http.get(`api/get_accesses_user`).then(res => {
        this.accesses = res.body
      })
      if (this.$route.params.id) { // Quando entra na tarefa pelo link sem ser compartilhado
        // Já manda direto pra tela de gerenciamento
        this.selectCompany(this.$route.params.id)
        // Para não mudar pra consulta enquanto carrega o gerenciamento
        this.view = 0
      }
      this.field_errors = [{ field: 'illis_name', text: '', loading: false }, { field: 'cpfcnpj', text: '', loading: false }]
      this.editedItem = {googleMap: '', logo_path: '', id_text: '', fantasy_name: '', illis_name: '', type_person: 2, cpfcnpj: '', rgie: '', market: '', city: '', state: '', country: '', cep: '', neighborhood: '', complement: '', address: '', number: '', phone: '', email: '', links: '', bio: '', user: '', users: [], segment: [], active: true}
      this.defaultItem = {googleMap: '', logo_path: '', id_text: '', fantasy_name: '', illis_name: '', type_person: 2, cpfcnpj: '', rgie: '', market: '', city: '', state: '', country: '', cep: '', neighborhood: '', complement: '', address: '', number: '', phone: '', email: '', links: '', bio: '', user: '', users: [], segment: [], active: true}
      this.initialize()
    },
    mounted () {
      // Verifica a tab ára já abri-la quando carregar, usado para abrir as faturas
      if (this.$route.query['tab']) {
        this.tab = this.$route.query['tab']
      }
    },
    methods: {
      selectCompany (id) {
        this.editItemProcess({'id': id}, 4)
      },
      checkConnections () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/exist_connections_company/${this.editedItem.id}`).then((res) => {
          this.$store.commit('loader/change_dialog', false)
          if (res.body) {
            this.$store.commit('snackbar/change_values', {
              text: 'Não é possível excluir uma empresa com parcerias conectadas! Exclua as parcerias conectadas e tente novamente.',
              color: 'warning',
              timeout: 20000,
              dialog: true
            })
            this.closeDialogDelete()
          } else {
            this.confirmDeleteDialog = true
            this.dialogConfirm = false
          }
        })
      },
      closeConfirmDelete () {
        this.confirmDeleteDialog = false
        this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
      },
      acceptConfirmDelete () {
        this.confirmDeleteDialog = false
        this.deleteItem()
      },
      checkEditRoomEmpty (item, view) {
        this.$socket.emit('checkRoomEmpty', {room: `${this.entity}${item.id}_manage`, user_id: this.$auth.user().id, view: view, editRoom: `${this.entity}${item.id}_edit`})
      },
      confirmEdit () {
        this.editItem(this.editedItem, 3)
        this.confirmEditDialog = false
      },
      // Evento geral que, neste caso, é utilizado para atualizar as permissões na tela de consulta do participante.
      methodGeneralSocket (item) {
        // Encontramos a empresa cujas permissões deverão ser atualizadas
        let updateItems = this.items.find((val) => { return val.id === item.company_id })
        let updateAllItems = this.allItems.find((val) => { return val.id === item.company_id })
        // Atualizamos a propriedade "user" daquela empresa com os novos dados.
        Object.assign(updateItems.user[0], JSON.parse(JSON.stringify(item)))
        Object.assign(updateAllItems.user[0], JSON.parse(JSON.stringify(item)))
        // Se o usuário já for participante e estiver gerenciando/editando a empresa
        if (this.editedItem.id === item.company_id) {
          // Atualizamos também a propriedade "user" do editedItem para atualizar as permissões e tooltip do botão "Editar"
          Object.assign(this.editedItem.user[0], JSON.parse(JSON.stringify(item)))
        }
      },
      // Método utilizado para verificar a permissão para gerenciamento/edição de uma empresa.
      // Se o participante não for administrador da empresa, o botão de gerenciamento e exclusão na tela de consulta ficarão desabilitados.
      checkAdminPermission (admin, company, type) {
        this.companiesPermissionTooltip[`${company}_${type}`] = admin ? type : `Somente administradores desta empresa podem ${type.toLowerCase()}.`
        return admin
      },
      acceptInvite (item) {
        this.$store.commit('loader/change_dialog', true)
        item.user[0].status = 2
        this.$http.post(`api/handle_invite_user`, {id: item.user[0].id, status: 2}).then((res) => {
          Object.assign(this.items.find((val) => { return val.id === item.id }) || {}, item)
          Object.assign(this.allItems.find((val) => { return val.id === item.id }) || {}, item)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Convite de ${this.translate(`table.${this.entity}.title`)[0]} aceito com sucesso!`, color: 'success', dialog: true
          })
          // Para os participantes da empresa envia um evento que irá editar o registro do novo participante alterando as ações e o status para 'Aceito'
          this.$socket.emit('generalDetailsEvent', {
            data: item.user[0],
            details: 'users',
            responseEvent: 'editSocketDetails',
            room: `${this.entity}${item.id}_manage` // * Tela de gerenciamento
          })
          this.$socket.emit('generalDetailsEvent', {
            data: item.user[0],
            details: 'users',
            responseEvent: 'editSocketDetailsCompanyUser',
            room: `${this.entity}${item.id}_manage` // * Tela de participantes da empresa
          })
          this.reload = !this.reload
        })
      },
      denyInvite (item) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post(`api/handle_invite_user`, {id: item.user[0].id, status: 3}).then((res) => {
          this.items = this.items.filter((val) => { return val.id !== item.id })
          this.allItems = this.allItems.filter((val) => { return val.id !== item.id })
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Convite de ${this.translate(`table.${this.entity}.title`)[0]} recusado.`,
            color: 'success',
            dialog: true
          })
          // Para os participantes da empresa envia um evento que irá editar o registro do novo participante alterando as ações e o status para 'Recusado'
          item.user[0].status = 3
          this.$socket.emit('generalDetailsEvent', {
            data: item.user[0],
            details: 'users',
            responseEvent: 'editSocketDetails',
            room: `${this.entity}${item.id}_manage` // * Tela de gerenciamento
          })
          this.$socket.emit('generalDetailsEvent', {
            data: item.user[0],
            details: 'users',
            responseEvent: 'editSocketDetailsCompanyUser',
            room: `${this.entity}${item.id}_manage` // * Tela de participantes da empresa
          })
        })
      },
      afterUpdate (newValues) {
        var users = JSON.parse(JSON.stringify(newValues.users))
        // è tirado o users para não passar no Object.Assign e assim não perder o vinculo quando substitui o editedItem no evento "editSocketManagementDetails"
        delete newValues.users
        users.forEach((val) => {
          // Irá enviar o evento para o usuário que já for participante da empresa (convite aceito - status = 2)
          if ((val.status === 2) && (val.user_id !== this.$auth.user().id)) {
            this.$socket.emit('generalEvent', {
              data: newValues,
              responseEvent: 'editSocketItem',
              room: `${this.entity}${val.user_id}`
            })
          }
        })
        newValues.connection_company_connected.forEach((val) => {
          let values = {'connection_company': newValues, 'id': val.id, 'type_person': newValues.type_person, 'id_text': newValues.id_text + (newValues.illis_name ? ' (' + newValues.illis_name + ')' : ''), 'cpfcnpj': newValues.cpfcnpj}
          if (val.auto) {
            Object.assign(values, {
              'rgie': newValues.rgie,
              'city': newValues.city,
              'state': newValues.state,
              'country': newValues.country,
              'address': newValues.address,
              'number': newValues.number,
              'neighborhood': newValues.neighborhood,
              'complement': newValues.complement,
              'cep': newValues.cep,
              'phone': newValues.phone,
              'email': newValues.email
            })
          }
          this.$socket.emit('generalEvent', {
            data: {values: values, entity: 'parceria'},
            responseEvent: 'editSocketManagementDetails',
            room: `connections${val.company_id}_${val.id}`
          })
          this.$socket.emit('generalEvent', {
            data: values,
            responseEvent: 'editSocketItem',
            room: `connections${val.company_id}`
          })
        })
        this.$socket.emit('generalEvent', {
          data: {values: newValues, entity: 'empresa'},
          responseEvent: 'editSocketManagementDetails',
          room: `${this.entity}${newValues.id}_manage` // * Tela de gerenciamento
        })
      },
      afterDelete (oldValues) {
        let item = {text: `A empresa "${oldValues.id_text}" foi excluída do sistema. Será necessário recarregar a página.`}
        oldValues.users.forEach((val) => {
          // Os dois próximos eventos têm a função de mostrar uma alerta na tela do participante da empresa excluída solicitando que ele recarregue a página.
          // Podemos ter dois cenários:
          // 1 - Se o usuário que receber o evento estiver logado na empresa, o alerta deve ser mostrado imediatamente em qualquer parte do sistema.
          // Este evento é recebido no arquivo "In.vue" e então é feita a verificação para confirmar se ele está logado na empresa, se sim mostramos o alerta.
          this.$socket.emit('generalEvent', {
            data: Object.assign({company_id: oldValues.id}, item),
            notBroadcast: true,
            responseEvent: 'deleteSocketCompany',
            room: `user${val.user_id}`
          })
          // Evento de exclusão do registro para os participantes que estão na tela de consulta
          this.$socket.emit('generalEvent', {
            data: oldValues,
            responseEvent: 'deleteSocketItem',
            room: `${this.entity}${val.user_id}`
          })
        })
        // 2 - Se o usuário que receber o evento não estiver logado na empresa excluída mas estiver gerencianto/editando essa companhia, o alerta também
        // deve ser mostrado a ele. Então enviamos este evento para os participantes que estiverem na tela de gerenciamento. Ele também é recebido
        // no arquivo "In.vue" e lá é feita a verificação se o usuário que recebeu é um participante da empresa, se sim mostramos o alerta.
        this.$socket.emit('generalEvent', {
          data: item,
          notBroadcast: true,
          responseEvent: 'reloadPage',
          room: `companies${oldValues.id}_manage` // * Tela de gerenciamento
        })
      },
      checkPermission (companyId, type) {
        let hasPermission = true
        let access = this.accesses.filter((res) => {
          return res.company_id === companyId
        })[0]
        if (access) {
          let permissions = JSON.parse(access.permissions)
          permissions = permissions.filter((res) => {
            return res.id_text === 'companies'
          })[0]
          hasPermission = permissions ? permissions[type] : true
        }
        return hasPermission
      },
      controlGoogleAutocomplete () {
        if (document.getElementById('googleMap').value === '') {
          this.$refs.address.clear()
          this.editedItem = Object.assign(this.editedItem, {city: '', state: '', country: ''})
        } else {
          let googleMap = this.editedItem.googleMap
          // Inserido o recebimento de vazio, pois quando tenta passar o googleMap direto, considera que o valor é o mesmo e não altera
          if (this.$refs.address) {
            this.$refs.address.update(' ')
          }
          // Inserido o tempo para dar tempo do update acima se concluir
          setTimeout(() => {
            if (this.$refs.address) {
              this.$refs.address.update(googleMap)
            }
          }, 100)
        }
      },
      getCityData: function (addressData, placeResultData, id) {
        this.address = addressData
        if (addressData) {
          this.setAddress(addressData.locality, addressData.administrative_area_level_1, addressData.country)
        }
      },
      setAddress: function (city, state, country) {
        setTimeout(() => {
          if (this.$refs.address) {
            this.$refs.address.update(`${city ? `${city}, ` : ``}${state ? `${state}, ` : ``}${country || ``}`)
            Object.assign(this.editedItem, {city: city, state: state, country: country})
          }
        }, 200)
      },
      saveProcess (viewAfterSave = 1) {
        if (this.hasDBRule()) {
          return false
        }
        if (this.image) {
          this.$store.commit('loader/change_dialog', true)
          this.$http.post('api/company/upload', this.image).then(res => {
            this.blobImage = false
            this.image = ''
            this.editedItem.logo_path = res.bodyText
            this.$store.commit('loader/change_dialog', false)
            this.save(viewAfterSave)
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
          })
        } else {
          this.save(viewAfterSave)
        }
      },
      saveNew () {
        this.saveProcess(2)
      },
      saveEdit () {
        this.saveProcess(4)
      },
      uploadImage () {
        this.saving = true
        setTimeout(() => this.savedAvatar(), 1000)
      },
      changeImage (val) {
        this.image = val
        this.blobImage = true
      },
      beforeCreate () {
        this.labels(2)
        this.setAddress(this.editedItem.city, this.editedItem.state, this.editedItem.country)
      },
      beforeEditItem (oldValues, view) {
        // inicializa os campos referente ao tipo da pessoa
        this.labels(oldValues.type_person)
        this.$socket.emit('joinRoom', {room: `${this.entity}${oldValues.id}${view === 3 ? '_edit' : '_manage'}`, username: this.$auth.user().id_text, view: view})
        this.setAddress(this.editedItem.city, this.editedItem.state, this.editedItem.country)
      },
      beforeClose (viewAfterSave) {
        if (this.previousView === 4) {
          if (this.view === 3) {
            this.$socket.emit('leaveRoom', {room: `${this.entity}${this.editedItem.id}_edit`})
          }
          viewAfterSave = 4
        } else {
          this.$socket.emit('leaveRoom', {room: `${this.entity}${this.editedItem.id}_manage`})
        }
      },
      afterClose (values) {
        this.$router.push('/companies')
      },
      othersFields (item) {
        return [
          {field: this.translate('table.' + this.entity + '.field.type_person'), value: item.type_person ? (this.translate('value.company_type_person').filter(a => a.value === parseInt(item.type_person))[0].text) : ''},
          {field: this.translate('table.' + this.entity + '.field.rgie '), value: item.rgie ? item.rgie : ''},
          {field: this.translate('table.' + this.entity + '.field.city'), value: item.city ? item.city : ''},
          {field: this.translate('table.' + this.entity + '.field.cep'), value: item.cep ? item.cep : ''},
          {field: this.translate('table.' + this.entity + '.field.neighborhood '), value: item.neighborhood ? item.neighborhood : ''},
          {field: this.translate('table.' + this.entity + '.field.complement'), value: item.complement ? item.complement : ''},
          {field: this.translate('table.' + this.entity + '.field.address '), value: item.address ? item.address : ''},
          {field: this.translate('table.' + this.entity + '.field.number'), value: item.number ? item.number : ''},
          {field: this.translate('table.' + this.entity + '.field.phone'), value: item.phone ? item.phone : ''},
          {field: this.translate('table.' + this.entity + '.field.email '), value: item.email ? item.email : ''}
        ]
      },
      labels: function (val) {
        setTimeout(() => {
          switch (val) {
            case 1:
              // Verificar se o cpfcnpj existe pois ele pode vir com null do banco de dados
              this.editedItem.cpfcnpj = (this.editedItem.cpfcnpj ? this.editedItem.cpfcnpj.substring(0, 11) : this.editedItem.cpfcnpj)
              this.cpfcnpj_mask = '###.###.###-##'
              this.cpfcnpj_label = 'CPF'
              this.rgie_label = 'RG'
              break
            case 2:
              this.cpfcnpj_mask = '##.###.###/####-##'
              this.cpfcnpj_label = 'CNPJ'
              this.rgie_label = 'IE'
              break
          }
        }, 300)
      }
    },
    computed: {
      socketRoom: function () {
        return `${this.entity || ''}${this.$auth.user().id}`
      },
      filterTypes: function () {
        return [
          {field: 'id_text', type: 'string'}
          // O campo ativo foi ocultado da tela de companhia. Posteriormente será retrabalhado e voltará a ser exibido
          // {field: 'active', type: 'boolean'}
        ]
      },
      headers: function () {
        return [
          {text: this.translate(`table.${this.entity}.field.id_text`), value: 'id_text', width: '35%'},
          {text: this.translate(`table.${this.entity}.field.cpfcnpj`), value: 'cpfcnpj', width: '15%'},
          {text: this.translate(`table.${this.entity}.field.illis_name`), value: 'illis_name', width: '25%'},
          {text: this.translate(`table.${this.entity}.field.plan`), value: 'props.item.company_plan.plan.id_text', width: '15%'},
          // O campo ativo foi ocultado da tela de companhia. Posteriormente será retrabalhado e voltará a ser exibido
          // {text: this.translate(`table.${this.entity}.field.active`), value: 'active'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    },
    watch: {
      avatar: {
        handler: function () {
          this.saved = false
        },
        deep: true
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: this.socketRoom})
      // Sai das salas de gerenciamento e edição caso o usuário troque de tela enquanto ele está gerenciando/editando uma tarefa
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.editedItem.id}_manage`})
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.editedItem.id}_edit`})
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Company.vue